function Home() {
    return (
    //   <div className="App">
         <div className="App">
        <div class="main">
          <div class="container">
            <div class="container-sub-one">
              <div class="container-sub-one-left">
                <img src="logo2.jpg" alt="quiz-app-logo" class="logo-image" />
              </div>
              <div class="container-sub-one-right">
                <div class="container-sub-one-right-left">
                  <h3>QuizMania</h3>
                  
                  {/* <p class="trademark">All Rights Reserved &copy;2023-&infin; Ajinkya Pradhan</p> */}
                </div>
                <div class="container-sub-one-right-right">
                    <a href='/contact'>Contact</a>                 
                </div>

              </div>

            </div>

            <div class="container-sub-two">
                <div class="container-sub-two-container">
                  <div class="container-sub-two-container-1">

                    <div class="container-sub-two-container-1-1">
                        <div class="flip-card">
                          <div class="flip-card-inner">
                            <div class="flip-card-front">
                              <img class="flip-top" src="images/back_cartoons.jpg" alt="Cartoons"></img>
                            </div>
                            <div class="flip-card-back">
                              <h1>Cartoons</h1>
                              <button class="button-24">
                              <a href='/cartoons'>Explore</a></button>
                            </div>
                          </div>
                        </div>
                        
                    </div>

                    <div class="container-sub-two-container-1-2">
                          <div class="flip-card">
                            <div class="flip-card-inner">
                              <div class="flip-card-front">
                                <img class="flip-top" src="images/personalities.jpeg" alt="Cartoons"></img>
                              </div>
                              <div class="flip-card-back">
                              <h1>Personalities</h1>
                              <button class="button-24"><a href='/person'>Explore</a></button>
                              </div>
                            </div>
                          </div>
                    </div>
                  </div>

                  <div class="container-sub-two-container-2">
                      <div class="container-sub-two-container-2-1">
                          <div class="flip-card">
                            <div class="flip-card-inner">
                              <div class="flip-card-front">
                                <img class="flip-top" src="images/sports.jpg" alt="Cartoons"></img>
                              </div>
                              <div class="flip-card-back">
                              <h1>Sports</h1>
                              <button class="button-24"><a href='/sports'>Explore</a></button>
                              </div>
                            </div>
                          </div>
                      </div>

                      <div class="container-sub-two-container-2-2">
                          <div class="flip-card">
                            <div class="flip-card-inner">
                              <div class="flip-card-front">
                                <img class="flip-top" src="images/animals.jpeg" alt="Cartoons"></img>
                              </div>
                              <div class="flip-card-back">
                              <h1>Animals</h1>
                              <button class="button-24"><a href='/animals'>Explore</a></button>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>

                  <div class="container-sub-two-container-3">
                      <div class="container-sub-two-container-3-1">
                          <div class="flip-card">
                            <div class="flip-card-inner">
                              <div class="flip-card-front">
                                <img class="flip-top" src="images/atlas.jpg" alt="Cartoons"></img>
                              </div>
                              <div class="flip-card-back">
                                <h1>Atlas</h1>
                                <button class="button-24"><a href='/atlas'>Explore</a></button>
                              </div>
                            </div>
                          </div>
                      </div>

                      <div class="container-sub-two-container-3-2">
                          <div class="flip-card">
                            <div class="flip-card-inner">
                              <div class="flip-card-front">
                                <img class="flip-top" src="images/tourism.jpg" alt="Cartoons"></img>
                              </div>
                              <div class="flip-card-back">
                                <h1>Tourism</h1>
                                <button class="button-24"><a href='/food'>Explore</a></button>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>

                  <div class="container-sub-two-container-4">
                      <div class="container-sub-two-container-4-1">
                          <div class="flip-card">
                            <div class="flip-card-inner">
                              <div class="flip-card-front">
                                <img class="flip-top" src="images/movies2.jpg" alt="Cartoons"></img>
                              </div>
                              <div class="flip-card-back">
                              <h1>Movies</h1>
                              <button class="button-24"><a href='/movies'>Explore</a></button>
                              </div>
                            </div>
                          </div>
                      </div>

                      <div class="container-sub-two-container-4-2">
                          <div class="flip-card">
                            <div class="flip-card-inner">
                              <div class="flip-card-front">
                                <img class="flip-top" src="images/comingSoon2.webp" alt="Cartoons"></img>
                              </div>
                              <div class="flip-card-back">
                                <img class="smiley" src="/images/smiley.jpeg" alt="comingSoon"/>
                              </div>
                            </div>
                          </div>
                      </div>
                  </div>

                </div>
            </div>
              <p class="trademark">All Rights Reserved &copy;2023-&infin; Ajinkya Pradhan</p>
          </div>
          
        </div>
      </div> 
      
  
  
    //   {/* </div> */}
    );
  }
  
  export default Home;